import Http from '@/services/httpAcademy'

export const listPromotions   = (params)           => Http.get('/admin/promotions', { params })
export const createPromotion  = (data)             => Http.post('/admin/promotions', data)
export const updatePromotion  = ({ id, ...data })  => Http.patch(`/admin/promotions/${id}`, data)
export const deletePromotion  = (id)               => Http.delete(`/admin/promotions/${id}`)
